import { ApiFactoryClassType } from './factory';
import { FormValues } from '../components/form/types';
import {
    ApartmentDetailResponse,
    DistrictDetailResponse, DistrictListResponse,
    PropertyDetailResponse, PropertyListResponse,
    ReportMessagesResponse, ReportTopicDetailResponse, ReportTopicListResponse,
} from './types/property';
import { RemoveResponse } from './types';

const property = (factory: ApiFactoryClassType) => ({
    getDistrictList: async (
        limit: number = 15,
        offset: number = 0,
        sort?: string,
        order?: 'asc' | 'desc',
    ): Promise<DistrictListResponse | null> => {
        const session = factory.getSession();
        if (!session || !session.auth || !session.auth.access_token) {
            return Promise.reject('no active session');
        }
        try {
            const response = await fetch(
                new URL(
                    `/api/district/list?limit=${limit}&offset=${offset}${sort && order ? `&sort=${sort}&order=${order}` : ``}`,
                    factory.getApiHost(),
                ),
                {
                    method: 'GET',
                    headers: {
                        Authorization: 'Bearer ' + session.auth.access_token,
                    },
                    mode: 'cors',
                },
            );

            if (!response.ok) {
                factory.onError(response);
            }

            if (response.status >= 400) {
                return null;
            }

            return response.json();
        } catch (e) {
            factory.onNetworkError();
            return null;
        }
    },
    getDistrictById: async (
        id: string,
    ): Promise<DistrictDetailResponse | null> => {
        const session = factory.getSession();
        if (!session || !session.auth || !session.auth.access_token) {
            return Promise.reject('no active session');
        }
        try {
            const response = await fetch(
                new URL(`/api/district/${id}`, factory.getApiHost()),
                {
                    method: 'GET',
                    headers: {
                        Authorization: 'Bearer ' + session.auth.access_token,
                    },
                    mode: 'cors',
                },
            );

            if (!response.ok) {
                factory.onError(response);
            }

            if (response.status >= 400) {
                return null;
            }

            return response.json();
        } catch (e) {
            factory.onNetworkError();
            return null;
        }
    },
    createNewDistrict: async (districtObj: FormValues): Promise<DistrictDetailResponse | null> => {
        const session = factory.getSession();
        if (!session || !session.auth || !session.auth.access_token) {
            return Promise.reject('no active session');
        }
        try {
            const response = await fetch(
                new URL(`/api/district/create`, factory.getApiHost()),
                {
                    method: 'POST',
                    body: JSON.stringify(districtObj),
                    headers: {
                        Authorization: 'Bearer ' + session.auth.access_token,
                        'Content-Type': 'application/json',
                    },
                    mode: 'cors',
                },
            );

            if (!response.ok) {
                factory.onError(response);
            }

            if (response.status >= 400) {
                return null;
            }

            return response.json();
        } catch (e) {
            factory.onNetworkError();
            return null;
        }
    },
    updateDistrict: async (id: string, districtObj: FormValues): Promise<DistrictDetailResponse | null> => {
        const session = factory.getSession();
        if (!session || !session.auth || !session.auth.access_token) {
            return Promise.reject('no active session');
        }
        try {
            const response = await fetch(
                new URL(`/api/district/${id}`, factory.getApiHost()),
                {
                    method: 'PUT',
                    body: JSON.stringify(districtObj),
                    headers: {
                        Authorization: 'Bearer ' + session.auth.access_token,
                        'Content-Type': 'application/json',
                    },
                    mode: 'cors',
                },
            );

            if (!response.ok) {
                factory.onError(response);
            }

            if (response.status >= 400) {
                return null;
            }

            return response.json();
        } catch (e) {
            factory.onNetworkError();
            return null;
        }
    },
    deleteDistrict: async (id: string) => {
        const session = factory.getSession();
        if (!session || !session.auth || !session.auth.access_token) {
            return Promise.reject('no active session');
        }
        try {
            const response = await fetch(
                new URL(`/api/district/${id}`, factory.getApiHost()),
                {
                    method: 'DELETE',
                    headers: {
                        Authorization: 'Bearer ' + session.auth.access_token,
                        'Content-Type': 'application/json',
                    },
                    mode: 'cors',
                },
            );

            if (!response.ok) {
                factory.onError(response);
            }

            if (response.status >= 400) {
                return null;
            }

            return response.json();
        } catch (e) {
            factory.onNetworkError();
            return null;
        }
    },
    getPropertyList: async (
        limit: number = 15,
        offset: number = 0,
        sort?: string,
        order?: 'asc' | 'desc',
    ): Promise<PropertyListResponse | null> => {
        const session = factory.getSession();
        if (!session || !session.auth || !session.auth.access_token) {
            return Promise.reject('no active session');
        }
        try {
            const response = await fetch(
                new URL(
                    `/api/property/list?limit=${limit}&offset=${offset}${sort && order ? `&sort=${sort}&order=${order}` : ``}`,
                    factory.getApiHost(),
                ),
                {
                    method: 'GET',
                    headers: {
                        Authorization: 'Bearer ' + session.auth.access_token,
                    },
                    mode: 'cors',
                },
            );

            if (!response.ok) {
                factory.onError(response);
            }

            if (response.status >= 400) {
                return null;
            }

            return response.json();
        } catch (e) {
            factory.onNetworkError();
            return null;
        }
    },
    getPropertyById: async (
        id: string,
    ): Promise<PropertyDetailResponse | null> => {
        const session = factory.getSession();
        if (!session || !session.auth || !session.auth.access_token) {
            return Promise.reject('no active session');
        }
        try {
            const response = await fetch(
                new URL(`/api/property/${id}`, factory.getApiHost()),
                {
                    method: 'GET',
                    headers: {
                        Authorization: 'Bearer ' + session.auth.access_token,
                    },
                    mode: 'cors',
                },
            );

            if (!response.ok) {
                factory.onError(response);
            }

            if (response.status >= 400) {
                return null;
            }

            return response.json();
        } catch (e) {
            factory.onNetworkError();
            return null;
        }
    },
    updateProperty: async (id: string, propertyObj: FormValues) => {
        const session = factory.getSession();
        if (!session || !session.auth || !session.auth.access_token) {
            return Promise.reject('no active session');
        }
        try {
            const response = await fetch(
                new URL(`/api/property/${id}`, factory.getApiHost()),
                {
                    method: 'PUT',
                    body: JSON.stringify(propertyObj),
                    headers: {
                        Authorization: 'Bearer ' + session.auth.access_token,
                        'Content-Type': 'application/json',
                    },
                    mode: 'cors',
                },
            );

            if (!response.ok) {
                factory.onError(response);
            }

            return response.json();
        } catch (e) {
            factory.onNetworkError();
            return null;
        }
    },
    createNewProperty: async (propertyObj: FormValues) => {
        const session = factory.getSession();
        if (!session || !session.auth || !session.auth.access_token) {
            return Promise.reject('no active session');
        }
        try {
            const response = await fetch(
                new URL(`/api/property/create`, factory.getApiHost()),
                {
                    method: 'POST',
                    body: JSON.stringify(propertyObj),
                    headers: {
                        Authorization: 'Bearer ' + session.auth.access_token,
                        'Content-Type': 'application/json',
                    },
                    mode: 'cors',
                },
            );

            if (!response.ok) {
                factory.onError(response);
            }

            return response.json();
        } catch (e) {
            factory.onNetworkError();
            return null;
        }
    },
    deleteProperty: async (id: string) => {
        const session = factory.getSession();
        if (!session || !session.auth || !session.auth.access_token) {
            return Promise.reject('no active session');
        }
        try {
            const response = await fetch(
                new URL(`/api/property/${id}`, factory.getApiHost()),
                {
                    method: 'DELETE',
                    headers: {
                        Authorization: 'Bearer ' + session.auth.access_token,
                        'Content-Type': 'application/json',
                    },
                    mode: 'cors',
                },
            );

            if (!response.ok) {
                factory.onError(response);
            }

            if (response.status >= 400) {
                return null;
            }

            return response.json();
        } catch (e) {
            factory.onNetworkError();
            return null;
        }
    },
    getApartmentById: async (
      id: string,
    ): Promise<ApartmentDetailResponse | null> => {
        const session = factory.getSession();
        if (!session || !session.auth || !session.auth.access_token) {
            return Promise.reject('no active session');
        }
        try {
            const response = await fetch(
              new URL(`/api/apartment/${id}`, factory.getApiHost()),
              {
                  method: 'GET',
                  headers: {
                      Authorization: 'Bearer ' + session.auth.access_token,
                  },
                  mode: 'cors',
              },
            );

            if (!response.ok) {
                factory.onError(response);
            }

            if (response.status >= 400) {
                return null;
            }

            return response.json();
        } catch (e) {
            factory.onNetworkError();
            return null;
        }
    },
    updateApartmentConsumption: async (id: string, apartmentConsumptionObj: FormValues) => {
        const session = factory.getSession();
        if (!session || !session.auth || !session.auth.access_token) {
            return Promise.reject('no active session');
        }
        try {
            const response = await fetch(
              new URL(`/api/apartment/${id}/consumption`, factory.getApiHost()),
              {
                  method: 'PUT',
                  body: JSON.stringify(apartmentConsumptionObj),
                  headers: {
                      Authorization: 'Bearer ' + session.auth.access_token,
                      'Content-Type': 'application/json',
                  },
                  mode: 'cors',
              },
            );

            if (!response.ok) {
                factory.onError(response);
            }

            if (response.status >= 400) {
                return null;
            }

            return response.json();
        } catch (e) {
            factory.onNetworkError();
            return null;
        }
    },
    getReportList: async (
        limit: number = 15,
        offset: number = 0,
        sort?: string,
        order?: 'asc' | 'desc',
    ): Promise<ReportTopicListResponse | null> => {
        const session = factory.getSession();
        if (!session || !session.auth || !session.auth.access_token) {
            return Promise.reject('no active session');
        }
        try {
            const response = await fetch(
                new URL(
                    `/api/report/list?limit=${limit}&offset=${offset}${sort && order ? `&sort=${sort}&order=${order}` : ``}`,
                    factory.getApiHost(),
                ),
                {
                    method: 'GET',
                    headers: {
                        Authorization: 'Bearer ' + session.auth.access_token,
                    },
                    mode: 'cors',
                },
            );

            if (!response.ok) {
                factory.onError(response);
            }

            if (response.status >= 400) {
                return null;
            }

            return response.json();
        } catch (e) {
            factory.onNetworkError();
            return null;
        }
    },
    getReportById: async (
        id: string,
    ): Promise<ReportTopicDetailResponse | null> => {
        const session = factory.getSession();
        if (!session || !session.auth || !session.auth.access_token) {
            return Promise.reject('no active session');
        }
        try {
            const response = await fetch(
                new URL(`/api/report/${id}`, factory.getApiHost()),
                {
                    method: 'GET',
                    headers: {
                        Authorization: 'Bearer ' + session.auth.access_token,
                    },
                    mode: 'cors',
                },
            );

            if (!response.ok) {
                factory.onError(response);
            }

            if (response.status >= 400) {
                return null;
            }

            return response.json();
        } catch (e) {
            factory.onNetworkError();
            return null;
        }
    },
    getReportMessages: async (
        id: string,
    ): Promise<ReportMessagesResponse | null> => {
        const session = factory.getSession();
        if (!session || !session.auth || !session.auth.access_token) {
            return Promise.reject('no active session');
        }
        try {
            const response = await fetch(
                new URL(`/api/report/${id}/messages`, factory.getApiHost()),
                {
                    method: 'GET',
                    headers: {
                        Authorization: 'Bearer ' + session.auth.access_token,
                    },
                    mode: 'cors',
                },
            );

            if (!response.ok) {
                factory.onError(response);
            }

            if (response.status >= 400) {
                return null;
            }

            return response.json();
        } catch (e) {
            factory.onNetworkError();
            return null;
        }
    },
    createNewReport: async (reportObj: FormValues): Promise<ReportTopicDetailResponse | null> => {
        const session = factory.getSession();
        if (!session || !session.auth || !session.auth.access_token) {
            return Promise.reject('no active session');
        }
        try {
            const response = await fetch(
                new URL(`/api/report/create`, factory.getApiHost()),
                {
                    method: 'POST',
                    body: JSON.stringify(reportObj),
                    headers: {
                        Authorization: 'Bearer ' + session.auth.access_token,
                        'Content-Type': 'application/json',
                    },
                    mode: 'cors',
                },
            );

            if (!response.ok) {
                factory.onError(response);
            }

            if (response.status >= 400) {
                return null;
            }

            return response.json();
        } catch (e) {
            factory.onNetworkError();
            return null;
        }
    },
    updateReport: async (id: string, reportObj: FormValues): Promise<ReportTopicDetailResponse | null> => {
        const session = factory.getSession();
        if (!session || !session.auth || !session.auth.access_token) {
            return Promise.reject('no active session');
        }
        try {
            const response = await fetch(
                new URL(`/api/report/${id}`, factory.getApiHost()),
                {
                    method: 'PUT',
                    body: JSON.stringify(reportObj),
                    headers: {
                        Authorization: 'Bearer ' + session.auth.access_token,
                        'Content-Type': 'application/json',
                    },
                    mode: 'cors',
                },
            );

            if (!response.ok) {
                factory.onError(response);
            }

            if (response.status >= 400) {
                return null;
            }

            return response.json();
        } catch (e) {
            factory.onNetworkError();
            return null;
        }
    },
    deleteReport: async (id: string): Promise<RemoveResponse | null> => {
        const session = factory.getSession();
        if (!session || !session.auth || !session.auth.access_token) {
            return Promise.reject('no active session');
        }
        try {
            const response = await fetch(
                new URL(`/api/report/${id}`, factory.getApiHost()),
                {
                    method: 'DELETE',
                    headers: {
                        Authorization: 'Bearer ' + session.auth.access_token,
                        'Content-Type': 'application/json',
                    },
                    mode: 'cors',
                },
            );

            if (!response.ok) {
                factory.onError(response);
            }

            if (response.status >= 400) {
                return null;
            }

            return response.json();
        } catch (e) {
            factory.onNetworkError();
            return null;
        }
    },
    createNewReportMessage: async (id: string, reportMessageObj: FormValues): Promise<ReportTopicDetailResponse | null> => {
        const session = factory.getSession();
        if (!session || !session.auth || !session.auth.access_token) {
            return Promise.reject('no active session');
        }
        try {
            const response = await fetch(
                new URL(`/api/report/${id}/messages/new`, factory.getApiHost()),
                {
                    method: 'POST',
                    body: JSON.stringify(reportMessageObj),
                    headers: {
                        Authorization: 'Bearer ' + session.auth.access_token,
                        'Content-Type': 'application/json',
                    },
                    mode: 'cors',
                },
            );

            if (!response.ok) {
                factory.onError(response);
            }

            if (response.status >= 400) {
                return null;
            }

            return response.json();
        } catch (e) {
            factory.onNetworkError();
            return null;
        }
    },
});

export default property;
